import { Component, input, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { InputProps } from '@miq/shared-models';
import { TitleCasePipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { L10nTranslatePipe } from 'angular-l10n';
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'miq-filter-bar-label',
  template: `
    @if (!!props().field) {
      <div class="filterbar-label">
        @if (props()?.isLabelTranslated) {
          @if (props()?.isTitleCaseRequired !== false) {
            <span>{{
              props().label || props().field | titlecase
            }}</span>
          } @else {
            <span>{{ props().label || props().field }}</span>
          }
        } @else {
          @if (props()?.isTitleCaseRequired !== false) {
            <span>{{
              props().label || props().field | translate | titlecase
            }}</span>
          } @else {
            <span>{{ props().label || props().field | translate }}</span>
          }
        }
        @if (!!props().hint) {
          <mat-icon
            [svgIcon]="props().hint.svgIcon"
            [matTooltip]="props().hint.textMessage"
            matTooltipClass="report-tooltip"
          ></mat-icon>
        }
      </div>
    }
    `,
  styleUrl: './filter-bar-label.component.scss',
  imports: [MatIcon, MatTooltip, TitleCasePipe, L10nTranslatePipe],
})
export class FilterBarLabelComponent implements OnInit, OnDestroy {
  props = input<InputProps>();
  ngOnInit() {
    // required by language
  }
  ngOnDestroy() {
    /* label translation purpose added */
  }
}
